export default "__VITE_ASSET__n_vB9fxn__"